import { render, staticRenderFns } from "./statisticSe.vue?vue&type=template&id=2a84a138&scoped=true"
import script from "./statisticSe.vue?vue&type=script&lang=js"
export * from "./statisticSe.vue?vue&type=script&lang=js"
import style0 from "./statisticSe.vue?vue&type=style&index=0&id=2a84a138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a84a138",
  null
  
)

export default component.exports